import { Result } from '@standardnotes/domain-core';
export class GenerateUuid {
    constructor(crypto) {
        this.crypto = crypto;
    }
    execute() {
        const uuid = this.crypto.generateUUID();
        return Result.ok(uuid);
    }
}
